import * as React from 'react'
import styled from 'styled-components'
import { ViewBase } from '@bestyled/primitives'
import { commonProps, CommonProps } from '@bestyled/system'

export type SpacerProps = CommonProps

/** The Spacer component is a generic flex child that expands to fill its parent has margin, padding, width, height */
export const Spacer = styled(ViewBase<SpacerProps>('Spacer'))`
  flex-grow: 1;
  ${commonProps}
` as React.FC<SpacerProps>
